// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/sbg-sens-announcements-equity/sbg-sens-announcements-equity.component.scss
// module id = 753
// module chunks = 0